import React from 'react';
import { translate } from 'react-i18next';
import { SubtotalsListItem } from './SubtotalsListItem';
export var TaxSum = translate()(function (_a) {
    var t = _a.t, moneyFormatter = _a.moneyFormatter, taxes = _a.taxes;
    return (taxes === null || taxes === void 0 ? void 0 : taxes.length) ? (React.createElement(SubtotalsListItem, { dataHook: "totals-tax", label: t('price-quote.view.totals.taxes'), value: moneyFormatter(taxes.reduce(function (sum, tax) { return sum + tax.taxed.serializedValue; }, 0)) })) : null;
});
//# sourceMappingURL=TaxSum.js.map